__turbopack_context__.v({
  "SectionImage": "Home-module-scss-module__mWrZaG__SectionImage",
  "SectionImage_ActionLabel": "Home-module-scss-module__mWrZaG__SectionImage_ActionLabel",
  "SectionImage_ActionWrapper": "Home-module-scss-module__mWrZaG__SectionImage_ActionWrapper",
  "SectionImage_Cover": "Home-module-scss-module__mWrZaG__SectionImage_Cover",
  "SectionImage_HintText": "Home-module-scss-module__mWrZaG__SectionImage_HintText",
  "SectionImage_PlayBtn": "Home-module-scss-module__mWrZaG__SectionImage_PlayBtn",
  "SectionImage_Wrapper": "Home-module-scss-module__mWrZaG__SectionImage_Wrapper",
  "boatColItem": "Home-module-scss-module__mWrZaG__boatColItem",
  "boat_card_card": "Home-module-scss-module__mWrZaG__boat_card_card",
  "boatsGridActionWrapper": "Home-module-scss-module__mWrZaG__boatsGridActionWrapper",
  "boatsGridContainer": "Home-module-scss-module__mWrZaG__boatsGridContainer",
  "boatsGridWrapper": "Home-module-scss-module__mWrZaG__boatsGridWrapper",
  "boatsGridWrapper_gray": "Home-module-scss-module__mWrZaG__boatsGridWrapper_gray",
  "boatsGridWrapper_white": "Home-module-scss-module__mWrZaG__boatsGridWrapper_white",
  "wrapper": "Home-module-scss-module__mWrZaG__wrapper",
});
